import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { initializeLaunchDarklyDatadogIntegration } from '@/lib/monitoring/launchdarkly-datadog-integration';

export function useLaunchDarklyDatadogIntegration() {
  const ldClient = useLDClient();

  useEffect(() => {
    if (!ldClient) {
      return;
    }

    const cleanup = initializeLaunchDarklyDatadogIntegration(ldClient);

    return () => {
      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, [ldClient]);
}
